// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"636":"landing","742":"public-document","945":"dashboard"}[chunkId] + "." + {"636":"3f40e3ae","742":"f90234ee","945":"9e10347e"}[chunkId] + ".chunk.css";
};